import { StyleSheet } from 'react-native'
import HelperPlatform from 'utils/helper-platform'

export const GraphContainerStyles = StyleSheet.create({
	container: {
		...HelperPlatform.select({
			web: {
				minHeight: '200px',
			}
		}),
	}
})
